<template>
    <div v-if="transactionLines.length > 0" class="text-sm text-highlighted">
        <div class="font-semibold mb-4">
            Transaksjonslinjer
            <UBadge
                size="sm"
                icon="i-ph-sparkle"
                label="AI"
                color="neutral"
                variant="subtle"
                :ui="{
                    base: 'bg-violet-100 text-violet-700 ring-violet-300',
                }"
            />
        </div>
        <div
            v-for="(line, index) in transactionLines"
            :key="line.entryLineIndex ?? index"
            class="grid grid-cols-2 gap-2"
        >
            <template v-for="row in getRows(line)" :key="row.label">
                <div class="">{{ row.label }}</div>
                <div class="text-right">{{ row.value || '' }}</div>
            </template>
            <USeparator type="dashed" class="col-span-2 my-4"/>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatCurrency, formattedDate } from '@/services/formatter.service'
import { Bookkeepable, TransactionEntryLinePartial } from '@/assignments/BookkeepingActionable/BookkeepingActionable.type'
import { findSubAccountByUuid } from '@/subaccount/subAccount.service'

const props = defineProps({
    actionable: {
        type: Object as () => Bookkeepable,
        required: true
    }
})

const transactionLines = computed(() => {
    return props.actionable.transactionEntryLines || []
})

const getRows = (line: TransactionEntryLinePartial) => [
    { label: 'Leverandør', value: getSupplierName(line) },
    { label: 'Debet', value: line.debitAccount },
    { label: 'Kredit', value: line.creditAccount },
    { label: 'Beskrivelse', value: line.description },
    { label: 'Forfallsdato', value: formattedDate(line?.invoiceDueDate ?? undefined) },
    { label: 'Beløp', value: formatCurrency(line?.amount ?? undefined) },
]

const getSupplierName = (line: TransactionEntryLinePartial) => {
    if (line.creditSubAccount) {
        const subAccount = findSubAccountByUuid(line.creditSubAccount)
        return subAccount?.name ?? ''
    }
    return ''
}

</script>

<style scoped>
</style>